import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import DataTable from '../../components/Table/DataTable';

import { showAlert } from '../../store/ducks/alert';
import { CircularProgress } from '@material-ui/core';

import { getIssuesWithoutCategory } from '../../services/issue';

const IssuesWithoutCategory = props => {
  const dispatch = useDispatch();
  const [issues, setIssues] = useState([]);
  const [page, setPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [pageTitle, setPageTitle] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isOrdering, setIsOrdering] = useState(0);
  const [search, setSearch] = useState({
    searchItem: 'categoryId',
    search: '',
  });

  useEffect(() => {
    displayIssuesWithoutCategory();
  }, []);

  const displayIssuesWithoutCategory = async () => {
    try {
      setIsLoading(true);
      const { data } = await getIssuesWithoutCategory(page, search);
      setIssues(data.rows);
      setPageTitle('Issues without category');
      setTotalItems(data.count);
      setTotalPages(data.pages);
      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert('error', error.message));
      console.log(error);
    }
  };

  const headers = ['uid', 'categoryId'];

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="channels-container">
        <h1>Issues related to "{pageTitle}"</h1>
      </div>

      <DataTable
        useUid
        head={headers}
        body={issues}
        bodyColumn={headers}
        action={true}
        linkPath={'issues'}
        totalPages={totalPages}
        currentPage={page}
        setPageChange={setPage}
        bodyColumn={headers}
        isNotOrdenable
      />
    </>
  );
};

export default IssuesWithoutCategory;
